import React, {
  forwardRef,
  useEffect,
  useState,
  useImperativeHandle,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearEvent,
  getCacheRoute,
  getClientHeight,
  getSettings,
  trigger,
  watchEvent,
} from '@/store/slices/appSlice'
import { Button, Card, Modal } from '@arco-design/web-react'
import getUrlParams from '@/utils/getUrlParams'
import { findTreeItem } from '@/utils/tools'
import { useI18n } from '@/hooks/useLocale'
import { getConfiguration } from '@/store/slices/userSlice'
export const LoongInFormWrap = forwardRef(
  ({ FormEdit, formRoute, ...options }, ref) => {
    //改造部分begin
    const t = useI18n()
    const dispatch = useDispatch()
    const configuration = useSelector(getConfiguration)
    const menuTrees = configuration?.menuTrees
    const appEvent = useSelector(watchEvent)
    const [id, setId] = useState(null)
    const [disabled, setDisabled] = useState(false)
    const [isInitUrlDataErrorVisible, setIsInitUrlDataErrorVisible] =
      useState(false)
    const [formData, setFormData] = useState(null)
    const [extraFormData, setExtraFormData] = useState(null)
    const [formEvent, setFormEvent] = useState(null)
    const [ErrorText, setErrorText] = useState(
      t('t_formInitUrlDataError')
    )
    const cacheRoute = useSelector(getCacheRoute)
    const clientHeight = useSelector(getClientHeight)
    const settings = useSelector(getSettings)
    const urlParams = getUrlParams()
    const showNavbar = settings.navbar && urlParams.navbar !== false
    const showFooter = settings.footer && urlParams.footer !== false
    const dynamic = findTreeItem(menuTrees, 'key', formRoute)?.dynamic
    const [isInit, setIsInit] = useState(false)
    useEffect(() => {
      if (
        appEvent &&
        appEvent.name == 'history.push' &&
        appEvent.params == formRoute &&
        appEvent.data
      ) {
        const dataid = appEvent?.data?.id
        let findObj = undefined
        setExtraFormData(appEvent.data?.extraFormData)
        if (dynamic) {
          findObj = cacheRoute.find(
            (c) => c.cacheKey == formRoute + '/' + (dataid ? dataid : 'create')
          )
          if (!findObj) {
            return
          }
          //已经初始化了就返回
          if (isInit && id == dataid) {
            setDisabled(appEvent.data.disabled)
          }
          if (isInit) return
        } else {
          findObj = cacheRoute.find((c) => c.cacheKey == formRoute)
        }
        if (dataid) setId(dataid)
        else setId('')
        setDisabled(appEvent.data.disabled)
        if (dataid) {
          setFormData(appEvent.data.formData)
          setFormEvent({
            name: 'showAndSwitchTab',
            params: ['0'],
          })
        } else {
          //添加
          if (appEvent?.data?.formData) {
            setFormData(appEvent.data.formData)
          }
          setFormEvent({
            name: 'resetForm',
            params: [],
            callback: (initItem) => {
              //需要改变初始数据在这里处理
            },
          })
        }

        setIsInit(true)
        setTimeout(() => {
          dispatch(clearEvent())
        }, 0)
      }
    }, [appEvent, cacheRoute, formRoute])

    const onSubmit = () => {
      dispatch(
        trigger({
          name: formRoute + '/onSubmit',
          formRoute,
          id: dynamic ? (id ? id : 'create') : undefined,
        })
      )
      const eventId = dynamic ? (id ? id : 'create') : undefined
      let addId = ''
      if (eventId) {
        addId = '/' + eventId
      }
      dispatch(trigger({ name: 'history.close', params: formRoute + addId }))
    }
    const onCancel = () => {
      const eventId = dynamic ? (id ? id : 'create') : undefined
      let addId = ''
      if (eventId) {
        addId = '/' + eventId
      }
      dispatch(trigger({ name: 'history.close', params: formRoute + addId }))
    }
    const onInitUrlDataError = async (
      errorMessage = t('t_formInitUrlDataError')
    ) => {
      await setErrorText(errorMessage)
      setIsInitUrlDataErrorVisible(true)
    }
    const onOk = () => {
      dispatch(
        trigger({
          name: 'history.close',
          params: `${formRoute}/${id || 'create'}`,
        })
      )
    }
    useImperativeHandle(ref, () => ({
      onInitUrlDataError,
    }))
    return (
      <div>
        <Card style={{ minWidth: '1000px' }}>
          {isInit && (
            <FormEdit
              className="form-wrap"
              formType="div"
              height={
                clientHeight -
                (showNavbar ? 60 : 0) - //头部
                28 - //面包屑
                4 - //上边距
                16 - //下边距
                40 - //导航页签
                (showFooter ? 20 : 0) + //底部
                48 //补偿值
              }
              id={id}
              formData={formData}
              event={formEvent}
              disabled={disabled}
              extraFormData={extraFormData}
              onSubmit={onSubmit}
              onCancel={onCancel}
              onInitUrlDataError={onInitUrlDataError}
              formRoute={formRoute}
              {...options}
            />
          )}
        </Card>
        <Modal
          title={t('t_remind')}
          visible={isInitUrlDataErrorVisible}
          cancelText={undefined}
          autoFocus={false}
          maskClosable={false}
          closable={false}
          escToExit={false}
          focusLock={true}
          footer={
            <>
              <Button type="primary" onClick={() => onOk()}>
                {t('b_confirm')}
              </Button>
            </>
          }
        >
          <p>{ErrorText}</p>
        </Modal>
      </div>
    )
  }
)

